import { truncate } from '@/utils';
import getObjField from './get-obj-field';

export default {
  truncate,
  getObjField,
};
